import React from "react";

const ProcessingBar2 = () => {
  return (
    <span className="block w-2 h-2 rounded-full bg-redlight animate-flash" />
  );
};

export default ProcessingBar2;
